// extracted by mini-css-extract-plugin
export var backgroundContainer = "index-module--backgroundContainer---zEhT";
export var valueAndMission = "index-module--valueAndMission--xp9ig";